<template>
  <div>
    <Modal
      v-model="modalShow"
      :width="1000"
      title="阅读情况"
      :footer-hide="true"
    >
      <Tabs
        v-model="tabsName"
        type="card"
        :animated="false"
        @on-click="handletabsChange"
      >
        <TabPane label="已读用户" name="1"> </TabPane>
        <TabPane label="未读用户" name="2"> </TabPane>
      </Tabs>
      <div class="operation-list">
        <Table
          ref="selection"
          border
          stripe
          max-height="600"
          :columns="column"
          :loading="loading"
          :data="Data"
          @on-selection-change="handletableSelect"
        >
          <template slot="gradeName" slot-scope="{ row }">
            <div>{{ row.gradeName }}{{ row.className }}</div>
          </template>
        </Table>
        <Page
          :total="pageInfo.total"
          show-total
          show-elevator
          show-sizer
          :page-size-opts="pageSizeOpts"
          :current="pageInfo.pageNum"
          class="page-right"
          @on-change="handlePageChange"
          @on-page-size-change="handlePageSize"
        ></Page>
      </div>
      <div class="modal-footer">
        <Button @click="handleColse" class="btn">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { tableColumnsWidth, key, slot } from "@/assets/js/resetTableStyle";
import eduCenter from "@/request/eduCenter/index.js";

export default {
  props: {},
  data() {
    return {
      pageSizeOpts: [10, 20, 50, 100],
      modalShow: false,
      tabsName: "1",
      loading: false,
      noticeId: "", //通知id
      Data: [],
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      column: [
        key("学生姓名", "studentName", tableColumnsWidth.type5),
        slot("年级班级", "gradeName", tableColumnsWidth.type3),
        key("阅读时间", "readTime", tableColumnsWidth.type5),
      ],
      selectData: [],
    };
  },
  created() {},
  methods: {
    // 获取通知阅读详情接口
    async getQueryNoticeRead() {
      const params = {
        noticeId: this.noticeId,
        isRead: this.tabsName == "1" ? 1 : 0,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
      };
      this.loading = true;
      const res = await eduCenter.getQueryNoticeRead(params);
      this.loading = false;
      if (res.status == 200) {
        this.Data = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    //tab切换
    handletabsChange() {
      this.getQueryNoticeRead();
    },
    handleOpen(noticeId) {
      this.modalShow = true;
      this.noticeId = noticeId;
      this.getQueryNoticeRead();
    },
    handleClosure() {
      this.modalShow = false;
    },
    //关闭
    handleColse() {
      this.modalShow = false;
    },
    //切换页面
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getQueryNoticeRead();
    },
    // 页条数改变
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum = 1;
      this.getQueryNoticeRead();
    },
    //表格选中
    handletableSelect(v) {
      this.selectData = v;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-footer {
  text-align: right;
  .btn {
    color: #515a6e;
    background-color: #fff;
    border-color: #dcdee2;
  }
}
.page-right {
  text-align: right;
  margin: 10px 0 20px;
}
</style>
